// assets/read-more.js
document.addEventListener('DOMContentLoaded', () => {
  initAll();

  // якщо у вас радіо-вкладки
  document.querySelectorAll('.tabs__item-input').forEach(radio => {
    radio.addEventListener('change', () => radio.checked && initAll());
  });

  function initAll() {
    document.querySelectorAll('.js-read-more').forEach(wrapper => {
      if (wrapper.dataset.rmReady) return;      // вже ініціалізовано

      const content = wrapper.querySelector('.js-read-more-content');
      const btn     = wrapper.querySelector('.js-read-more-toggle');
      if (!content || !btn) return;

      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';

        // Перемикаємо стан
        btn.setAttribute('aria-expanded', !expanded);
        content.classList.toggle('is-open');

        // Якщо щойно ЗГОРНУЛИ (тобто було expanded=true)
        if (expanded) {
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      wrapper.dataset.rmReady = '1';
    });
  }
});
